import { BUSINESS_TYPE_OPTIONS, businessTypeById } from '../../../types/BusinessType';
import './BusinessTypeField.css';

export default function BusinessTypeField({ typeId, onTypeIdChange, disabled }) {
  const selected = businessTypeById(typeId);

  return (
    <section className="shop-create-section">
      <div className="shop-create-label">Тип бизнеса <b style={{ color: 'red' }}>*</b></div>
      {/* <div className="shop-create-help">Как бизнес отдаёт товары</div> */}
      <div className="shop-type-options" role="radiogroup" aria-label="Тип бизнеса">
        {BUSINESS_TYPE_OPTIONS.map((option) => {
          const active = option.id === selected.id;
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={active}
              className={active ? 'shop-type-option shop-type-option--active' : 'shop-type-option'}
              disabled={disabled}
              onClick={() => onTypeIdChange?.(option.id)}
            >
              <span className="shop-type-name">{option.name}</span>
              {/* <span className="shop-type-help">{option.help}</span> */}
            </button>
          );
        })}
      </div>
    </section>
  );
}
